import moment from 'moment';
import { timeFilter, timeInterval } from '../constants';

/**
 * @param {Object} target Object passed from DOM event
 * @description Calculates the start and end time of some default time ranges.
 * The target value has to map to a key in the defaultFlowFilter object.
 */
export const getTimeRange = (target) => {
    const defaultFlowFilter = {
        [timeFilter.LAST_YEAR]: {
            from: moment().subtract(1, 'year').format(),
            to: moment().format(),
            groupBy: 'monthly',
            interval: timeInterval.LAST_YEAR,
        },
        [timeFilter.LAST_30_DAYS]: {
            from: moment().subtract(30, 'days').format(),
            to: moment().format(),
            groupBy: 'daily',
            interval: timeInterval.LAST_30_DAYS,
        },
        [timeFilter.LAST_7_DAYS]: {
            from: moment().subtract(7, 'days').format(),
            to: moment().format(),
            groupBy: 'daily',
            interval: timeInterval.LAST_7_DAYS,
        },
        [timeFilter.LAST_24_HOURS]: {
            from: moment().subtract(24, 'hours').format(),
            to: moment().format(),
            groupBy: 'hourly',
            interval: timeInterval.LAST_24_HOURS,
        },
    };

    return defaultFlowFilter[target.value];
};
